/**
 * Home Page
 * Landing page with overview and quick actions
 */

import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <div className="hero">
        <h1>Dial Sniper Command Center</h1>
        <p className="subtitle">
          Launch outbound dialing runs and classify outcomes with AMD + AI analysis.
        </p>
      </div>

      {/* Status Card
      <div className="card">
        <h3>System Status</h3>
        {health ? (
          <div className="status-grid">
            <div className="status-item">
              <span className={`status-dot ${health.status === 'healthy' ? 'green' : 'red'}`}></span>
              <span>API: {health.status}</span>
            </div>
            <div className="status-item">
              <span className={`status-dot ${health.twilio_configured ? 'green' : 'yellow'}`}></span>
              <span>Twilio: {health.twilio_configured ? 'Configured' : 'Not Configured'}</span>
            </div>
            <div className="status-item">
              <span className={`status-dot ${health.gemini_configured ? 'green' : 'yellow'}`}></span>
              <span>Gemini AI: {health.gemini_configured ? 'Configured' : 'Not Configured'}</span>
            </div>
          </div>
        ) : (
          <p className="error">Unable to connect to API. Make sure the backend is running.</p>
        )}
      </div> */}

      {/* How It Works */}
      <div className="card">
        <h3>How It Works</h3>
        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h4>Upload Excel File</h4>
              <p>Upload your lead file. Dial Sniper detects phone columns and prepares the run.</p>
            </div>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h4>Select Sheets</h4>
              <p>Select the sheets and columns you want to include in this dialing operation.</p>
            </div>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h4>Auto-Dial & Classify</h4>
              <p>Each number is dialed, AMD-tagged, and then AI-reviewed for final categorization.</p>
            </div>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h4>Download Results</h4>
              <p>Export the completed file with run statuses, category outcomes, and analysis metadata.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <Link to="/upload" className="btn btn-primary">
          🚀 Start Run
        </Link>
        <Link to="/history" className="btn btn-secondary">
          📋 View Runs
        </Link>
      </div>

      <style>{`
        .home-page {
          max-width: 800px;
          margin: 0 auto;
        }

        .hero {
          text-align: center;
          margin-bottom: 2rem;
        }

        .hero h1 {
          font-family: var(--font-sans);
          font-size: 2.5rem;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: var(--amber);
          text-shadow: 2px 2px 0 rgba(65,18,8,.9);
          margin-bottom: 0.5rem;
        }

        .subtitle {
          font-size: 1.25rem;
          color: var(--text-soft);
        }

        .status-grid {
          display: flex;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .status-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .status-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
        }

        .status-dot.green { background: var(--status-success-fg); }
        .status-dot.yellow { background: var(--amber); }
        .status-dot.red { background: var(--status-analysis-failed-fg); }

        .error {
          color: var(--status-analysis-failed-fg);
        }

        .steps {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .step {
          display: flex;
          gap: 1rem;
          align-items: flex-start;
        }

        .step-number {
          width: 32px;
          height: 32px;
          background: linear-gradient(135deg, var(--indigo) 0%, var(--teal) 100%);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          flex-shrink: 0;
        }

        .step-content h4 {
          color: var(--text-strong);
          margin: 0 0 0.25rem 0;
          text-transform: uppercase;
          letter-spacing: 0.04em;
        }

        .step-content p {
          margin: 0;
          color: var(--text-soft);
        }

        .quick-actions {
          display: flex;
          gap: 1rem;
          justify-content: center;
          margin-top: 2rem;
        }
      `}</style>
    </div>
  );
};

export default Home;
